import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=e69ca13a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e69ca13a')) {
      api.createRecord('e69ca13a', component.options)
    } else {
      api.reload('e69ca13a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=e69ca13a&", function () {
      api.rerender('e69ca13a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gpx4je7FWs50/JS/comp/childrenage.vue"
export default component.exports